
<div class="modal-dialog responsive-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body" style="margin: 15px; padding: 0">
      <table class="table table-responsive">
        <thead></thead>
        <tbody>
          <tr *ngFor="let info of metadata">
            <td>
              <h5>{{ info.name }}</h5>
            </td>
            <td>
              <select class="form-control form-control-sm" *ngIf="info.editable &amp;&amp; info.type === 'boolean'" [(ngModel)]="listItem[info.field]" [ngStyle]="{'width': info.width + 'px' }" name="{{info.field}}{{idx}}" required>
                <option *ngFor="let value of info.values" value="{{value.value}}">{{ value.name }}</option>
              </select>
              <textarea class="form-control form-control-sm" *ngIf="info.editable &amp;&amp; info.type === 'string'" name="{{info.field}}{{idx}}" [(ngModel)]="listItem[info.field]" type="text"></textarea>
              <input class="form-control form-control-sm" *ngIf="info.editable &amp;&amp; info.type === 'number'" name="{{info.field}}{{idx}}" [(ngModel)]="listItem[info.field]" [ngStyle]="{'width': info.width*2 + 'px' }" type="number">
              <select class="form-control form-control-sm" *ngIf="info.editable &amp;&amp; info.type === 'dropbox'" [(ngModel)]="listItem[info.field]" [ngStyle]="{'width': info.width + 'px' }" name="{{info.field}}{{idx}}" required>
                <option *ngFor="let value of info.values" value="{{value.value}}">{{ value.name }}</option>
              </select>
              <datepicker class="right datepicker-sm" *ngIf="info.editable &amp;&amp; info.type === 'date'" [(ngModel)]="listItem[info.field]" name="{{info.field}}{{idx}}Selector" [options]="info.options" showInput="{{info.field}}{{idx}}" required></datepicker>
              <div *ngIf="!info.editable">{{ listItem[info.field] }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="save()">Save</button>
      <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>